type SectionHeadingProps = {
  index: string;
  kicker: string;
  title: string;
  description?: string;
  align?: "left" | "center";
};

export default function SectionHeading({
  index,
  kicker,
  title,
  description,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "text-center" : "text-left"}>
      <div className={`flex items-center gap-3 ${isCenter ? "justify-center" : ""}`}>
        <span className="font-heading text-sm font-bold text-primary-600">{index}</span>
        <span className="h-px w-8 bg-primary-400"></span>
        <span className="text-xs tracking-[0.3em] text-foreground-500">{kicker}</span>
      </div>
      <h2 className="mt-4 font-heading text-2xl leading-tight text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {description ? (
        <p
          className={`mt-4 text-sm leading-relaxed text-foreground-600 md:text-base ${
            isCenter ? "mx-auto max-w-2xl" : "max-w-2xl"
          }`}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
}